import { Card, CardContent, CardMedia, Grid, Typography, CardActions } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import SeeMoreBtn from '../atoms/SeeMoreBtn'

import arrowDownloadIcon from '../../media/arrow_download_icon.svg'

const CardLeftRight = ({
	hasRightTitle,
	hasSeeMore,
	downloadLabel,
	children,
	bgcolor,
	imgFirst,
	src,
	video,
}) => {
	return (
		<Card
			sx={(theme) => ({
				display: 'flex',
				flexDirection: 'column',
				m: (theme) => theme.spacing((imgFirst && 4) || 8, 0, 12),
				borderRadius: 0,
				bgcolor: bgcolor || 'text.white',
				[theme.breakpoints.down('md')]: {
					mb: 0,
					pt: 3,
					mt: 2,
				},
			})}
		>
			<Grid
				container
				flexDirection={(hasRightTitle && 'row-reverse') || ''}
				sx={(theme) => ({
					justifyContent: 'space-between',
					flexBasis: '47%',

					[theme.breakpoints.down('md')]: {
						pt: 0,
						flexBasis: '100%',
					},

					'& img': {
						height: 'fit-content!important',
						width: '100%!important',

						[theme.breakpoints.down('md')]: {
							width: '100%',
						},
					},
					'& .MuiGrid-item': {
						px: 2,
					},
					[theme.breakpoints.down('md')]: {
						flexDirection: (imgFirst && 'column') || 'column-reverse',
						px: 0,
						'& .MuiGrid-item': {
							pt: 0,

							'&:nth-of-type(1)': {
								pb: 0,
							},
						},
					},
				})}
				justifyContent="center"
			>
				<Grid
					item
					xs={12}
					sx={{
						justifyContent: 'flex-end',
						display: (hasRightTitle && 'flex') || null,
					}}
					md={6}
				>
					<CardMedia
						component="div"
						sx={(theme) => ({
							mb: (imgFirst && 4) || '',
							flexBasis: '100%',

							[theme.breakpoints.down('md')]: {
								width: '100%',
								height: 'auto',
							},
							'& img': {
								display: 'block',
								borderRadius: '8px',
								height: 'fit-content!important',
								width: '100%!important',
							},

							'& iframe': {
								width: '100%',
							},
						})}
					>
						{src && <img src={src} alt="" />}
						{video && <Typography dangerouslySetInnerHTML={{ __html: video }} />}
					</CardMedia>
				</Grid>
				<Grid item xs={12} md={6} sx={{ '& figure': { display: 'none' }, width: '100%' }}>
					<CardContent sx={{ textAlign: 'left', mb: 0, p: 0, '& div': { width: '100%' } }}>
						{children}
					</CardContent>
					{hasSeeMore && (
						<CardActions mb={0} sx={{ padding: 0 }}>
							<SeeMoreBtn />
						</CardActions>
					)}
					{downloadLabel && (
						<CardActions mb={0} sx={{ padding: 0, mt: 4 }}>
							<Typography
								component="div"
								variant="div"
								sx={(theme) => ({
									color: 'secondary.main',
									fontSize: 16,
									fontWeight: 700,
									cursor: 'pointer',
									background: `url(${arrowDownloadIcon}) no-repeat right`,
									pr: 3,
								})}
							>
								{downloadLabel}
							</Typography>
						</CardActions>
					)}
				</Grid>
			</Grid>
		</Card>
	)
}

CardLeftRight.defaultProps = {
	hasRightTitle: false,
	hasSeeMore: false,
}

CardLeftRight.propTypes = {
	hasRightTitle: PropTypes.bool,
	hasSeeMore: PropTypes.bool,
}
export default CardLeftRight
